import history from "../../CreateHistory.js";
import { MsalAuthContext } from "./MSALAuthContext.js";
import navigationService from "../NavigationService.js";
import LocalStorageService from "../LocalStorageService.js";
import { BST_ENABLE_MSAL_TESTING } from "../../constants/QueryString.constants.js";
import { LOCAL_STORAGE_CONSTANTS } from "../../constants/LocalStorage.constants.js";
const enableMsalTesting = navigationService.getUrlParam(BST_ENABLE_MSAL_TESTING);
if (enableMsalTesting === "1") {
  LocalStorageService.setItem(LOCAL_STORAGE_CONSTANTS.enableMsalTesting, true);
}
const MSALAuthService = new MsalAuthContext(history);
export {
  MSALAuthService as default
};
//# sourceMappingURL=MSALAuthService.js.map
